export enum APIRequestResources {
    AuthService = 'auth',
    BuyerService = 'buyers',
    CustomerCategoryService = 'customer-category',
    CustomerReferenceService = 'customer-reference',
    TaskResource = 'task',
    TaskSummaryCountsResource = 'task/summary/counts',
    TaskSearchResource = 'task/search',
    StageResource = 'stage',
    processResource = 'process',
    stageButtonResource = 'stage-buttons',
    stageTransitionResource = 'stage-transition',
    AttachmentResource = 'attachment',
    TaskTimingResource = 'task-timing',
    CustomerService = 'customers',
    InquiryService = 'sales-inquiry',
    CurrencyService = 'currency',
    DepartmentService = 'department',
    EmployeeService = 'employee',
    HsCodeService = 'hs-code',
    IdentityService = 'identity',
    InvoiceService = 'invoice',
    PackingListService = 'packing-list',
    ProductDesignService = 'product-designs',
    ProductSampleService = 'product-samples',
    ProductTypeService = 'product-type',
    ResourcesService = 'identity/resources',
    SalesOrderItemService = 'sales-order-item',
    SalesOrderItemBreakdownService = 'sales-order-item-breakdown',
    SalesOrderService = 'sales-order',
    UsersService = 'identity/users',
    UnitService = 'unit',
    MaximAPIService = '',
    CustomerPriceService = 'customer-price',
    ReportService = 'report',
    ProductionService = 'production',
    ProductionPlanService = 'production-plan',
    CROService = 'cro',
    SalesOwnerService = 'sales-owner',
    SalesDashboardService = 'sales',
    SharepointService = 'sharepoint',
    InvoiceTaxCalculateService = 'tax',
    WarehouseService = 'plant',
    CreditNoteService = 'credit-note',
    NcrService = 'ncr',
    PackagingService = 'packing-list',
    InvoiceTrackService = 'invoice-track',
    SalesMapService = 'sales-map',
    ProductPriceService = 'product-price',
    ProductionStatusService = 'production-stages',
    LabelTypesService = 'label-types',
    InventoryItemsService = 'inventory-items',
    ProductionPlaningService = 'production-plan',
    WorkOrderService = 'work-order',
    FinishGoodService = 'finish-good',
    ArtworkService = 'artworks',
    ProductLibrarayService = 'product-library',
    MachineService = 'machines',
    FinishingService = 'finishings',
    InventoryService = 'inventory',
    InkSupplierService = 'suppliers',
    InkBoardService = 'boards',
    InkRecipeService = 'recipes',
    InkBaseColorService = 'base-colors',

}

export enum MASPortalResources {
    MasPoGetServiceService = 'purchaseOrder',
    DeliveryConfirmationService = 'delivery-confirmation',
    MasPackingListUploadService = 'packing-plan-upload',
    MasInvoiceUploadService = 'invoice-upload',
}

export enum GooglePlaceResources {
    Place = 'places',
}
